import Vue from 'vue'
import Vuex from 'vuex'
//import axios from 'axios'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    authState: {
      token: localStorage.getItem('token-pos') || '',
      loggedUser: JSON.parse(localStorage.getItem('logged-pos')) || '',
      status: 'notlogged',
    },
    settings: {},
    control: JSON.parse(localStorage.getItem('control')) || {},
  },
  getters: {
    isAuthenticated: state => !!state.authState.token,
    authStatus: state => state.authState.status,
    loggedUser: state => state.authState.loggedUser,
    settings: state => state.settings,
  },
  mutations: {
    saveControl(state, control){
      localStorage.setItem('control',JSON.stringify(control));
      state.control = control
    },
    deleteControl(state){
      localStorage.removeItem('control');
      state.control = null
    },
    authSuccess(state, {token, loggedUser} ) {
      state.authState.status = 'logged';
      state.authState.token = token;
      state.authState.loggedUser = loggedUser;
      localStorage.setItem('logged-pos', JSON.stringify(loggedUser));
    },
    logout(state) {
      state.authState.token = '';
      state.authState.loggedUser = {};
      state.authState.status = 'notlogged';
      localStorage.removeItem('logged-pos');
    },
    storeSettings(state,settings){
      state.settings = settings;
    },
  },
})